export type TGradients = 'brand' | 'vibrantBrand' | 'brandLoop' | 'vibrantBrandLoop';

type GradientsType = { [key in TGradients]: string[] };

const gradients: GradientsType = {
  brand: ['#f87a7a', '#f9947d', '#f57ab1', '#e07de8', '#dbb2ed', '#efb4c9'],
  brandLoop: ['#f87a7a', '#f9947d', '#f57ab1', '#e07de8', '#dbb2ed', '#efb4c9', '#f87a7a'],
  vibrantBrand: ['#f87a7a', '#f9947d', '#f57ab1', '#e07de8'],
  vibrantBrandLoop: ['#f87a7a', '#f9947d', '#f57ab1', '#e07de8', '#f57ab1', '#f9947d', '#f87a7a'],
};

export default gradients;
